<template>
  <section class="pt-0 pb-8 sm:pb-10 px-4 sm:px-6" id="feature-cards">
    <div class="max-w-7xl mx-auto">
      <h2 class="text-2xl sm:text-3xl md:text-4xl font-bold text-white text-center mb-3 animate-fade-in">Наши сильные стороны</h2>
      <p class="text-gray-400 text-sm sm:text-base md:text-xl text-center max-w-2xl mx-auto mb-6 animate-stagger-1">
        Познакомьтесь с принципом работы нашего сервиса и его ключевыми преимуществами
      </p>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 justify-items-center">
        <!-- Research Card -->
        <div class="bg-white rounded-3xl p-5 w-full max-w-xs flex flex-col feature-card" v-scroll-animation="{ once: true }">
          <h2 class="text-xl sm:text-2xl md:text-3xl font-semibold mb-2 text-gray-700">Быстрый доступ</h2>
          <p class="text-gray-600 mb-6 mt-2 text-sm sm:text-base"><span>Активация занимает до 24 часов — после этого вы сразу сможете оплачивать любые зарубежные сервисы</span></p>
        </div>

        <!-- Trends Card -->
        <div class="bg-green-50 rounded-3xl p-5 w-full max-w-xs flex flex-col feature-card" v-scroll-animation="{ once: true, threshold: 0.2 }">
          <h2 class="text-xl sm:text-2xl font-semibold mb-2 text-black">Безопасность</h2>
          <p class="text-gray-600 mb-6 text-sm sm:text-base">Ваши платежи защищены по международным стандартам VISA — данные доступны только вам</p>
        </div>
        
        <!-- Social Analysis Card -->
        <div class="bg-purple-50 rounded-3xl p-5 w-full max-w-xs flex flex-col feature-card" v-scroll-animation="{ once: true, threshold: 0.4 }">
          <h2 class="text-xl sm:text-2xl font-semibold mb-2 text-black">Постоянная поддержка</h2>
          <p class="text-gray-600 mb-6 text-sm sm:text-base">Если возникнут сложности, мы поможем на каждом этапе в процессе оплаты</p>
        </div>

        <!-- Content Creation Card -->
        <div class="bg-blue-600 rounded-3xl p-5 w-full max-w-xs text-white flex flex-col feature-card" v-scroll-animation="{ once: true, threshold: 0.5 }">
          <h2 class="text-xl sm:text-2xl font-semibold mb-2">Оплата Online</h2>
          <p class="text-blue-100 mb-6 text-sm sm:text-base">Вам не понадобится открывать банковский счет в другой стране</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FeatureCards'
})
</script>

<style scoped>
.feature-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  height: 100%;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

@media (max-width: 640px) {
  .feature-card {
    margin-bottom: 1rem;
  }
}
</style>
